import type { StateCreator} from 'zustand';
import {create} from 'zustand';
import type {FitbItemBankStore} from './types';
import { initialState} from './types';
import actions from './actions';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

const fitbItemBankStore: StateCreator<
  FitbItemBankStore,
  [['zustand/devtools', never], ['zustand/immer', never]]
> = (set, get) => ({
  ...initialState,
  ...actions(set, get)
});

const fitbItemBankCreator = create<FitbItemBankStore>();

export type ItemBankStoreInstance = ReturnType<typeof fitbItemBankCreator>;

export const createUseItemBankStoreInstance = () =>
  fitbItemBankCreator(devtools(immer(fitbItemBankStore), {name: 'fitb-item-bank-type'}));
export * from './types';
export * from './actions';
